import CouterUp from './src/countup.vue'

export default CouterUp
